import {Component, ElementRef, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {AuthenticationService, BaseComponent, Message} from 'iui-iconectiv-lib';
import {TruncatePipe} from '../shared';

import { InputMask } from 'primeng/inputmask';
import {Table} from 'primeng/table';
import {ReportsService} from './reports.service';
import { SortMeta } from 'primeng/api';

declare var $: any;



// query input ids
const INPUT_TNS = 'input-tns';
const INPUT_TN_FILE = 'input-tn-file';
const INPUT_TN_RANGE = 'input-tn-range';
const INPUT_CODE = 'input-code';
const INPUT_NPB = 'input-npb';


// search by
const BY_TNS = 'byTns';
const BY_TN_FILE = 'byTnFile';
const BY_TN_RANGE = 'byTnRange';
const BY_CODE = 'byCode';
const BY_NPB = 'byNpb';

// button style class
const BTN_DISABLED = 'btn-disabled';
const BTN_DEFAULT = 'btn-default';
const BTN_PRIMARY = 'btn-primary';

// invalid input css class name
const INVALID_INPUT = 'invalid-input';

const NO_RECORD_FOUND = 'No record found.';


// filename for download/ export
const CSV_FILENAME = 'lrn-results';

// error message
const ERROR_MESSAGE = 'The system was unsuccessful in processing your request. Please try again, or contact Customer Support for assistance.';


@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ReportsComponent extends BaseComponent implements OnInit {

  // p-inputMask fields
  @ViewChild('codeMask') codeMask: InputMask;
  @ViewChild('npbMask') npbMask: InputMask;
  @ViewChild('tnRangeMask') tnRangeMask: InputMask;

  // view buttons
  @ViewChild('viewTnRange') viewTnRange: ElementRef;
  @ViewChild('viewCode') viewCode: ElementRef;
  @ViewChild('viewNpb') viewNpb: ElementRef;

  // p-table
  @ViewChild('codeTable') codeTable: Table;
  @ViewChild('blockTable') blockTable: Table;
  @ViewChild('npbTable') npbTable: Table;
  @ViewChild('tnTable') tnTable: Table;

  // <input> of TN file
  @ViewChild('fileInput') fileInput: any;

  // objects contain results table definitions
 


  // search methods
  searchBy = BY_TNS; // by: BY_TNS, BY_TN_FILE, BY_TN_RANGE, BY_CODE, BY_NPB

  // style class for input
  iscTnRange = ''; // css class name; set to "invalid-input" when invalid input is detected.
  lrn = '';
  reportType = '';
  sortOrder: SortMeta;

  // style class for Export CSV button
  scBtnExportCsvLrn = BTN_PRIMARY;

  // style class for View Results button
  scBtnViewTnFile = BTN_DISABLED;
  scBtnViewTnRange = BTN_DISABLED;
  scBtnViewTns = BTN_DEFAULT;
  scBtnViewCode = BTN_DISABLED;
  scBtnViewNpb = BTN_DISABLED;

  // show "Back to Top" when scrolling off the page
  showHome: boolean;

  // show confirmation dialog for getting user's intent of View Results or Export to CSV
  showConfirmationDialog = false;

  // truncate threshold, if the length of the host string is longer, truncation will occur
  // default is 40 characters
  truncateThreshold = 40;


  constructor(    
    private reportsService: ReportsService,
    private authService: AuthenticationService,
    private truncatePipe: TruncatePipe
  ) {
    super();
  }


  ngOnInit() { 
    
    this.reportType = 'lrn';
   }


  


  /**
   * call base class's displayErrorMessage() for error.
   */
  displayError() {
    this.displayErrorMessage(new Message('Error', ERROR_MESSAGE));
  }

  


  /**
   * transform string for display, truncate the string if it is longer than the threshold
   */
  getUri(uri: string): string {
    if (uri && uri.length > 0) {
      return this.truncatePipe.transform(uri, this.truncateThreshold);
    } else {
      return 'n/a';
    }
  }

  /**
   * prepare tooltip string for the associate truncated string
   */
  getToolTip(uri: string): string {
    if (uri && uri.length > 0) {
      return uri;
    } else {
      return '';
    }
  }

  getSearchByLrn() {
   
    this.clearMessages();
    const input = this.lrn.replace(/\D/g, '');
    this.reportsService.getLrnData(input, 'csv').subscribe(
      data => {
        // this.log.debug(data);
        this.writeToFile(data, CSV_FILENAME);

        this.lrn = "";
      },
      error => {
        this.log.error(`search: get HttpError=${JSON.stringify(error)}`);
        this.displayError();
      }
    );
    
  }

  writeToFile(csv, outputFilename) {
    const blob = new Blob([csv], {
      type: 'text/csv;charset=utf-8;'
    });

    const nav = (window.navigator as any);

    if (nav.msSaveOrOpenBlob) {
      nav.msSaveOrOpenBlob(blob, outputFilename + '.csv');
    }
    else {
      const link = document.createElement('a');
      link.style.display = 'none';
      document.body.appendChild(link);
      if (link.download !== undefined) {
        link.setAttribute('href', URL.createObjectURL(blob));
        link.setAttribute('download', outputFilename + '.csv');
        link.click();
      }
      else {
        csv = 'data:text/csv;charset=utf-8,' + csv;
        window.open(encodeURI(csv));
      }
      document.body.removeChild(link);
    }

  }


  getBtnExportCsvLrn(): string {
    const completed = this.lrn && this.codeMask ? this.codeMask.isCompleted() : false;
    return completed ? BTN_PRIMARY : BTN_DISABLED;
  }

  // p-inputMask completed
  doComplete(id) {
    this.log.debug(`doComplete(): id=${id}`);

    switch (id) {
      case INPUT_CODE:
        this.scBtnExportCsvLrn = BTN_PRIMARY;
         break;
      
      default:
        break;
    }
  }

 


}

